import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export function ErrorPage(props) {

  return (
    <div className="error-page-container">
      <div>
        <h1 className="error-code-id">429</h1>
        <h2 style={{ zIndex: 3, position: 'relative' }}>We encountered an error loading this account.<br />Please try and log in again.</h2>
        <Link to="quickpay" style={{ zIndex: 3, position: 'relative', marginLeft: '200px' }}>
          <input className="blue-button" type="button" id="backToLogin" value="Log In" />
        </Link>
      </div>
    </div>
  );
}

export default ErrorPage;